import { merge } from 'lodash'

import * as siteActions from './siteActions'

export default merge(siteActions)
